<template>
    <header>
        <div class="logo">
            <router-link to="/">
                <img src="../assets/logo.png" alt="logo">
                Caby
            </router-link>
        </div>
        <nav class="list_items">
            <div class="menu_close">
                <button @click="removeMenu">
                    <img src="../assets/icon-close-menu.svg" alt="close-menu">
                </button>
            </div>
            <div class="menu_close">
                <button @click="removeMenu">
                    <img src="../assets/icon-close-menu.svg" alt="close-menu">
                </button>
            </div>
            <ul  @click="removeMenu">
                <li><router-link to="/">Home</router-link></li>
                <li><router-link to="/product">Product</router-link></li>
                <li><router-link to="/contact">Contact us</router-link></li>
                <li><router-link to="/about">About us</router-link></li>
            </ul>

            <!-- Login and register button for mobile and tablet view -->
            <div class="login">
                <button class="log">Register/Login</button>
            </div>

            <!-- Login and register button for mobile and tablet view -->
            <div class="login">
                <button class="log">Register/Login</button>
            </div>
        </nav>

        <!-- Login and register/button for desktop view -->

        <!-- Login and register/button for desktop view -->
        <div class="login">
            <button class="log">Register/Login</button>
            <button class="menu" @click="showMenu"><img src="../assets/icon-menu.svg" alt="menu"></button>
        </div>
    </header>
</template>
<script>
    export default {
        methods: {
            // Methods for showing and removing the menu on mobile view respectively.
            showMenu() {
                document.getElementsByClassName('list_items')[0].classList.add('show')
                
            },
            removeMenu() {
                document.getElementsByClassName('list_items')[0].classList.remove('show')
            }
        }

    }
</script>
<style scoped>
    header {
        position: fixed;
        margin: 0;
        min-height: 72px;
        padding: 0 1rem;
        padding: 0 1rem;
        width: 100%;
        top: 0;
        left: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #FFFFFF;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        font-family: 'Inter', sans-serif ;
        z-index: 100;
    }
    header .logo a{
        position: relative;
        display: flex;
        align-items: center;
        font-weight: 700;
        font-size: 25px;
        gap: 5px;
    }
    header .logo img{
        width: 28px;
        height: 32px;
    }
    header .list_items{
        position: relative;
    }
    .list_items ul{ 

        position: relative;
        margin: 0;
        padding: 0;
        list-style: none;
        display: flex;
        gap: 30px;
    }
    .list_items ul li a{
        margin: 0;
        padding: 0;
        font-weight: 400;
        color: #475467;
        font-size: 18px;
    }
    .list_items ul li a.router-link-active{
        color: #000;
    }
     .login button{
        background-color: transparent;
        background-color: transparent;
        border: none;
        font-size: 14px;
        border-radius: 30px;
        font-weight: 700;
        cursor: pointer;
        font-family: 'Inter', sans-serif ;
    }
    .login .log {
        padding: 12px 30px;
        color: #fff;
        background: #FF6600;
    }
    
    @media screen and (max-width: 767px) {
        header{
            background-color: #011A51;
        }
        header .logo a{
            color: #fff;
        }
        .login .log{
            display: none;
        }
        .list_items ul li a.router-link-active{
            color: #fff;
        }
        header .list_items{
            position: fixed;
        }
         .list_items{
            background-color: #011A51;
            z-index: 100;
            width: 100%;
            right: -100%;
            height: 100vh;
            transition: .3s;
            top: 0;
            padding: 20px;
        }
        
        .list_items ul{
            display: flex;
            flex-direction: column;
            margin-top: 4rem;
            justify-content: center;
            align-items: center;
        }
        .list_items ul li{
            margin-bottom: 1rem;
        }
        .list_items .login .log {
            display: unset;
            position: absolute;
            bottom: 10%;
            left: 50%;
            transform: translateX(-50%);
        }
        .list_items .menu_close{
            position: absolute;
            right: 20px;
            
        }
        .list_items .menu_close button{
            border: none;
            background-color: transparent;
            cursor: pointer;
        }
        .show{
            right: 0%;
        }
    }
    @media screen and (min-width: 768px) {
        header{
            padding: 0 2em;
        }
        .login .menu{
            display: none;
            cursor: pointer;
        }
        .list_items .menu_close{
            display: none;
            position: absolute;
            right: 0;
        }
        .list_items .login .log {
            display: none;
        }
    }
    @media screen and (min-width: 1010px) {
        header{
            padding: 0 4rem;
        }
        header .logo img{
            width: 38px;
            height: 48px;
        }
        .list_items ul{
            gap: 3.8em;
        }
    }

</style>